<div class="inside-container">
    <div fxLayout="row">
        <div fxFlex="70" fxLayoutAlign="start center">
            <h3
                class="tab-header"
                i18n="@@3cb901a060f771a8256dfa24e88dd3c1793546a0"
                t="3cb901a060f771a8256dfa24e88dd3c1793546a0"
                >Manufacturing Site</h3
            >
            <a target="_blank" [href]="helpUrl">
                <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
            </a>
        </div>
    </div>
    <br />
    <div fxLayout="row" fxLayoutGap="5px">
        <tsl-form-field fxFlex="30">
            <tsl-select fullWidth (selectionChange)="onChangeLocation($event)">
                <tsl-option value="0"></tsl-option>
                <tsl-option *ngFor="let item of locations$ | async" [value]="item.id">
                    {{ item.tags.fullAddress }}</tsl-option
                >
            </tsl-select>
        </tsl-form-field>
    </div>
    <br />

    <!-- Details -->
    <mat-expansion-panel [expanded]="true" *ngIf="currentLocationId > 0">
        <mat-expansion-panel-header>
            <mat-panel-title
                i18n-matTooltip
                matTooltip="Click to expand/collapse"
                i18n="@@edc1c39664e63d7366853af0e7e1889cb5a78829"
                t="edc1c39664e63d7366853af0e7e1889cb5a78829"
                >Description of Plant</mat-panel-title
            >
        </mat-expansion-panel-header>

        <div [formGroup]="siteForm">
            <div class="row" fxLayoutAlign="space-around center" fxLayoutGap="10px">
                <div fxFlex>
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="measureType"
                            i18n="@@978a0d8b93cf136c18d08c9e6fcf1995bd896338"
                            t="978a0d8b93cf136c18d08c9e6fcf1995bd896338"
                            >Unit of measure</tsl-label
                        >
                        <tsl-select id="measureType" fullWidth formControlName="measureType">
                            <tsl-option *ngFor="let item of unitOfMeasure" [value]="item.id"
                                >{{ translate.get(item.measureType) }}
                            </tsl-option>
                        </tsl-select>
                    </tsl-form-field>
                </div>
                <div fxFlex>
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="productionSize"
                            i18n="@@08d76cc879157c46de3dfd69153050fad494d406"
                            t="08d76cc879157c46de3dfd69153050fad494d406"
                            >Manufacturing Production Area</tsl-label
                        >
                        <input
                            id="productionSize"
                            tslInput
                            fullWidth
                            type="number"
                            min="0"
                            formControlName="productionSize"
                        />
                        <tsl-hint align="end">{{ translate.get(measureType) }}</tsl-hint>
                    </tsl-form-field>
                </div>
                <div fxFlex>
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="warehouseSize"
                            i18n="@@ee9dbb7b1c2079b621016f4d0cb654c1227675e5"
                            t="ee9dbb7b1c2079b621016f4d0cb654c1227675e5"
                            >Part Storage</tsl-label
                        >
                        <input
                            id="warehouseSize"
                            tslInput
                            fullWidth
                            type="number"
                            min="0"
                            formControlName="warehouseSize"
                        />
                        <tsl-hint align="end">{{ translate.get(measureType) }}</tsl-hint>
                    </tsl-form-field>
                </div>
                <div fxFlex>
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="plantArea"
                            i18n="@@e34e40827eb286a89b517da010c7259d30a0b9f7"
                            t="e34e40827eb286a89b517da010c7259d30a0b9f7"
                            >Plant Operations Area</tsl-label
                        >
                        <input tslInput fullWidth type="number" disabled [value]="plantArea" />
                        <tsl-hint align="end">{{ translate.get(measureType) }}</tsl-hint>
                    </tsl-form-field>
                </div>
                <div fxFlex>
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="officeSize"
                            i18n="@@6e3e64e992330d52009730b96f338d7abe16f4d6"
                            t="6e3e64e992330d52009730b96f338d7abe16f4d6"
                            >Office Area</tsl-label
                        >
                        <input id="officeSize" tslInput fullWidth type="number" min="0" formControlName="officeSize" />
                        <tsl-hint align="end">{{ translate.get(measureType) }}</tsl-hint>
                    </tsl-form-field>
                </div>
            </div>
            <div class="row" fxLayoutAlign="space-around center" fxLayoutGap="10px">
                <div fxFlex="19.3">
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="manufacturingEmployeeNo"
                            i18n="@@1825492c9f08f580cee1eeb72fbcf9495be47f06"
                            t="1825492c9f08f580cee1eeb72fbcf9495be47f06"
                            >Number of Production Employees
                        </tsl-label>
                        <input
                            id="manufacturingEmployeeNo"
                            tslInput
                            fullWidth
                            type="number"
                            min="0"
                            formControlName="manufacturingEmployeeNo"
                        />
                    </tsl-form-field>
                </div>
                <div fxFlex="19.3">
                    <tsl-form-field fxFlex>
                        <tsl-label
                            for="engineerEmployeeNo"
                            i18n="@@f9b729008e391e8401734d68591fa54ecaa309ec"
                            t="f9b729008e391e8401734d68591fa54ecaa309ec"
                            >Number of Engineering Employees
                        </tsl-label>
                        <input
                            id="engineerEmployeeNo"
                            tslInput
                            fullWidth
                            type="number"
                            min="0"
                            formControlName="engineerEmployeeNo"
                        />
                    </tsl-form-field>
                </div>
                <div fxFlex fxLayoutAlign="end center">
                    <button
                        tsl-button
                        filled
                        size="small"
                        color="blue"
                        (click)="onSaveTab()"
                        i18n="@@Save"
                        t="Save"
                        >Save</button
                    >
                </div>
            </div>
        </div>
    </mat-expansion-panel>
    <br />

    <!-- Certifications -->
    <mat-expansion-panel [expanded]="true" *ngIf="currentLocationId > 0">
        <mat-expansion-panel-header>
            <mat-panel-title
                i18n-matTooltip
                matTooltip="Click to expand/collapse"
                i18n="@@86213002d144661644c35fd219687620f4c5976b"
                t="86213002d144661644c35fd219687620f4c5976b"
                >Certifications</mat-panel-title
            >
        </mat-expansion-panel-header>

        <div class="right-container">
            <button
                tsl-button
                color="black"
                size="small"
                outline
                (click)="onAddCertification()"
                i18n="@@888625c5949149caf88a3c072a07b0ac31543cf7"
                t="888625c5949149caf88a3c072a07b0ac31543cf7"
                >Add Certification
            </button>
        </div>
        <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
            <ng-container tslColumnDef="type">
                <th
                    tsl-sort-header
                    tsl-header-cell
                    *tslHeaderCellDef
                    i18n="@@1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                    t="1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                    >What Certification?
                </th>
                <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.certificationType) }} </td>
            </ng-container>

            <ng-container tslColumnDef="certified">
                <th
                    tsl-sort-header
                    tsl-header-cell
                    *tslHeaderCellDef
                    i18n="@@600889f42ed29c7e8d6759417e8ec18b9a269f51"
                    t="600889f42ed29c7e8d6759417e8ec18b9a269f51"
                    >When Did You Get Certified?
                </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.certifiedDate | date }} </td>
            </ng-container>

            <ng-container tslColumnDef="expired">
                <th
                    tsl-sort-header
                    tsl-header-cell
                    *tslHeaderCellDef
                    i18n="@@5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                    t="5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                    >When Does The Certificate Expire?
                </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.expirationDate | date }} </td>
            </ng-container>

            <ng-container tslColumnDef="certifier">
                <th
                    tsl-sort-header
                    tsl-header-cell
                    *tslHeaderCellDef
                    i18n="@@59d00489a2079a4dd908b127a544d316b6f58a18"
                    t="59d00489a2079a4dd908b127a544d316b6f58a18"
                    >Who Certified It?
                </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.certifierName }} </td>
            </ng-container>

            <ng-container tslColumnDef="status">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@Status" t="Status">Status</th>
                <td tsl-cell *tslCellDef="let item">
                    <tsl-icon
                        status="primary"
                        *ngIf="getStatus(item.expirationDate) === 'active'"
                        tslTooltip="{{ getStatus(item.expirationDate) }}"
                        >thumb_up</tsl-icon
                    >
                    <tsl-icon
                        status="error"
                        *ngIf="getStatus(item.expirationDate) === 'expired'"
                        tslTooltip="{{ getStatus(item.expirationDate) }}"
                        >thumb_down</tsl-icon
                    >
                </td>
            </ng-container>

            <ng-container tslColumnDef="attachments">
                <th
                    tsl-header-cell
                    *tslHeaderCellDef
                    i18n="@@3471dfd9ec59caf4fe4c7692738806a9556674ec"
                    t="3471dfd9ec59caf4fe4c7692738806a9556674ec"
                >
                    Attachments
                </th>
                <td tsl-cell *tslCellDef="let item">
                    <div class="upload-bar">
                        <div class="file-list">
                            <ul>
                                <li *ngFor="let file of item.attachments">
                                    <tsl-icon
                                        size="small"
                                        status="error"
                                        (click)="onDeleteCertificationAttachment(file, item)"
                                        >delete</tsl-icon
                                    >
                                    <a
                                        class="small"
                                        (click)="onDownloadCertificatonAttachment(file)"
                                        tslTooltip="{{ file.fileName }}"
                                        >{{ file.fileName }}</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container tslColumnDef="action">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action">Action</th>
                <td tsl-cell *tslCellDef="let item">
                    <button tsl-icon-button i18n-matTooltip tslTooltip="Edit" (click)="onEditCertification(item)">
                        <tsl-icon>edit</tsl-icon>
                    </button>
                    <button tsl-icon-button i18n-matTooltip tslTooltip="Delete" (click)="onRemoveCertification(item)">
                        <tsl-icon status="error">delete</tsl-icon>
                    </button>
                </td>
            </ng-container>

            <tr tsl-header-row *tslHeaderRowDef="certificationColumns"></tr>
            <tr tsl-row *tslRowDef="let row; columns: certificationColumns"></tr>
        </table>

        <tsl-pagination
            [pageSizeOptions]="pageSizeOptions"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            showFirstLastButtons
            (pageChange)="onPageChange($event)"
            [total]="certifications.length"
            [itemsPerPageLabel]="translate.get('ItemsPerPage')"
        >
        </tsl-pagination>
    </mat-expansion-panel>
    <br />

    <!-- Product Experience -->
    <mat-expansion-panel [expanded]="true" *ngIf="currentLocationId > 0">
        <mat-expansion-panel-header>
            <mat-panel-title
                i18n-matTooltip
                matTooltip="Click to expand/collapse"
                i18n="@@ca22267e8646e7297625d621818f77c786b34409"
                t="ca22267e8646e7297625d621818f77c786b34409"
                >Product Experience
            </mat-panel-title>
        </mat-expansion-panel-header>

        <app-product-grid [supplierCode]="supplierCode" [siteId]="currentLocationId"></app-product-grid>
    </mat-expansion-panel>
</div>
